import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Typography } from '@mui/material';

function RenderPath(path, key, color) {
  const { href, text, type } = path;

  if (type === 'link') {
    return (
      <Link key={key} href={href} color="inherit" underline="hover">
        {text}
      </Link>
    );
  }

  return (
    <Typography key={key} component="span" fontWeight={600} color={color}>
      {text}
    </Typography>
  );
}

function BreadcrumbGeneratorComponent({ paths, mb, color = 'textPrimary' }) {
  return (
    <Breadcrumbs aria-label="breadcrumb" color={color} mb={mb}>
      {paths.map((path, index) =>
        RenderPath(path, `breadcrumb-${index}`, color)
      )}
    </Breadcrumbs>
  );
}

BreadcrumbGeneratorComponent.propTypes = {
  paths: PropTypes.instanceOf(Array).isRequired,
  mb: PropTypes.number,
};

BreadcrumbGeneratorComponent.defaultProps = {
  mb: 2,
};

export default BreadcrumbGeneratorComponent;
